import { IVasTypeInitialState } from "../../../types/master/vasTypeInterface";
import { VasTypeActionTypes, VasTypeActions } from "../../actionTypes/master/vasTypeActionTypes";

const initialState: IVasTypeInitialState = {
  vasTypeList: [],
  vasTypeListPageCount: 0,
  vasTypeData: {
    id: 0,
    code: "",
    display_name: "",
    description: "",
    is_mandatory: false,
    is_active: false,
  },
};

export default function vasTypeReducer(state = initialState, action: VasTypeActionTypes): IVasTypeInitialState {
  switch (action.type) {
    case VasTypeActions.SET_VAS_TYPE_LIST:
      return {
        ...state,
        vasTypeList: action.payload,
      };

    case VasTypeActions.SET_VAS_TYPE_LIST_PAGE_COUNT:
      return {
        ...state,
        vasTypeListPageCount: action.payload,
      };

    case VasTypeActions.SET_VAS_TYPE_DATA_BY_ID:
      return {
        ...state,
        vasTypeData: action.payload,
      };

    default:
      return state;
  }
}
